"use strict";

class CatalogueFilter {
	init() {
		$(() => {
			// eslint-disable-next-line
			const filter = document.querySelector(".catalogue__filter:not(.catalogue__filter--static)");

			// Terminate here and don't execute any other logic for all pages without the filter div
			if (filter === null) {
				return;
			}

			// Make sure position of filter is adjusted when screen gets resized
			$(window).on("resize", () => this.changeFilterPosition());

			// Toggle visibility on button click
			$(document).on("click", ".btn-filters", () => this.toggleFilter());

			// When there is an error in the form the filter height increases, thus the position needs to be adjusted.
			//   Once the dom loads, register an observer that triggers when a class is added to the input with the error.
			//   When it triggers it adjusts the position
			//   Note: It is important to filter the mutations that it should respond to otherwise this can lead to an
			//         infinite look and the page crashing.
			const observer = new MutationObserver((mutations) => {
				mutations.forEach(() => {
					this.changeFilterPosition();
				});
			});

			observer.observe(filter, {
				attributes: true,
				subtree: true,
				attributeFilter: ["class"],
			});

			// Once DOME loads check if the form has errors, if so toggle the filter open
			if ($(".catalogue__filter").hasClass("with-errors")) {
				this.toggleFilter();
			}
		});
	}

	/**
	 * Adjusts the top offset of the div so that it sits right above the open filter button.
	 */
	changeFilterPosition() {
		// eslint-disable-next-line
		const $filterDiv = $(".catalogue__filter:not(.catalogue__filter--static)");
		const filterDivHeight = $filterDiv.outerHeight();

		$filterDiv.css({ top: -filterDivHeight });
	}

	/**
	 * Shows or hides the filter div and rotates the arrow of the opening button indicating whether filter is opened or
	 * closed. It adjusts the position of the div once it's been shown.
	 * Note: adjusting the position before you show the div won't work as it's height will be 0.
	 */
	toggleFilter() {
		// eslint-disable-next-line
		$(".catalogue__filter:not(.catalogue__filter--static)").toggleClass("d-none");
		$(".btn-filters__title").toggleClass("d-none");
		$(".btn-filters__icon").toggleClass("rotate");

		this.changeFilterPosition();
	}
}

module.exports = new CatalogueFilter();
